<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("appointments/getDoctors");
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
    doctors() {
      return this.$store.state.appointments.doctors;
    },
    appointmentTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AppointmentTypes
      );
    },

    procedures() {
      return [{
        value: "خدمات قسم التجميل الجراحي",
        label: "خدمات قسم التجميل الجراحي"
      },
      {
        value: "خدمات قسم التجميل اللاجراحي",
        label: "خدمات قسم التجميل اللاجراحي"
      },
      {
        value: "خدمات قسم التغذية",
        label: "خدمات قسم التغذية"
      },
      {
        value: "خدمات قسم العناية بالبشرة",
        label: "خدمات قسم العناية بالبشرة"
      },
      {
        value: "خدمات قسم الليزر",
        label: "خدمات قسم الليزر"
      },{
        value: "كشوفات",
        label: "كشوفات "
      },]
    },
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },
  },
  data() {
    return {
      procedureId: null,

      dialog: false,
      selectedPriceItem: null,

      searchTrem: null,
      vm: {
        appointmentDate: null,
        doctorId: null,
        patientId: null,
        appointmentTypeId: null,
        appointmentType: null,
        remarks: null,
      },
      patient: {
        fullName: null,
        fileNo: null,

      },
      allowedDays: [],
      patients: [],
      selectedPatient: {
        fullName: null,
        fileNo: null
      },
      showResult: false,
      showBtn: false
    };
  },
  methods: {

    getServices() {
      this.vm.appointmentType = null;
      this.$store.dispatch("lookups/GetItemByProcedure", this.procedureId);
    },
    onPriceItemSelected() {
      const item = this.selectedPriceItem;
      if (item && item) {
        this.vm.appointmentType = item;
        this.showBtn = true;
      } else {
        this.vm.appointmentType = null;
      }
    },

    allowedDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // تصفير الوقت
      const selectedDate = new Date(date);
      const day = selectedDate.getDay(); // اليوم من الأسبوع
      const isDayAllowed = this.allowedDays.includes(day); // تحقق من الأيام المسموحة
      const isDateAllowed = selectedDate >= today; // تحقق من التاريخ

      return isDayAllowed && isDateAllowed; // تحقق من الشرطين
    },

    getDoctorAppointments() {
      this.allowedDays = [];
      this.doctors.forEach(element => {
        if (element.value == this.vm.doctorId) {
          element.appointmentSettings.forEach(e => {
            this.allowedDays.push(e.id)
          });
        }
      });
    },
    confirm() {
      if (this.vm.appointmentType != null) {
        let service = this.itemPriceList.find(x => x.itemName == this.vm.appointmentType);
        this.vm.serviceCode = service.itemCode;
      }

      this.$refs.form.validate().then(valid => {
        if (valid) {
          this.$store
            .dispatch("appointments/add", this.vm)
            .then(() => {
              this.back();
            })
            .catch(() => { });
        } else {
          showAlert(`الرجاء التحقق من تعبئة جميع الحقول  `);

        }
      });
    },
    checkAppointment() {
      this.showBtn = false;
      if (this.vm.appointmentTypeId == 8002) {
        this.$store
          .dispatch("appointments/checkAppointment", {
            patientId: this.vm.patientId,
            doctorId: this.vm.doctorId,
          }
          )
          .then((res) => {
            if (res != undefined) {
              this.showBtn = true;
            }
          })
          .catch(() => { });
      }
      else if (this.vm.appointmentTypeId == 8003) {
        this.$store
          .dispatch("appointments/checkFollowup", {
            patientId: this.vm.patientId,
            doctorId: this.vm.doctorId,
          }
          )
          .then((res) => {
            if (res != undefined) {
              this.showBtn = true;
            }
          })
          .catch(() => { });
      }
      else {
        this.showBtn = true;
      }
    },
    checkitemPriceList() {
      this.vm.itemPriceList = this.itemPriceList
    },
    SearchPatient() {
      this.showResult = false;
      this.patients = [];
      this.selectedPatient.fullName = null;
      this.selectedPatient.fileNo = null;
      this.vm = {
        appointmentDate: null,
        doctorId: null,
        patientId: null,
        appointmentTypeId: null,
        remark: null,
      };
      if (this.searchTrem == null || this.searchTrem == "" || this.searchTrem.length < 9) {
        showAlert(`الرجاء ادخال رقم الهاتف`);
        return false;
      }

      this.$store
        .dispatch("appointments/search", { searchTrem: this.searchTrem })
        .then((res) => {

          if (res.statusCode == 1) {
            this.showResult = true
            this.patients = res.patients;
            this.dialog = true;
          }
        })
        .catch(() => { });
    },
    confirmDialog() {
      let that = this;
      this.patients.forEach((el) => {
        if (that.vm.patientId == el.id) {

          that.selectedPatient = el
          return el
        }
      });

      this.dialog = false
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>